class Nav {
  constructor() {
    this.el = document.getElementById("jsNav");
    this.btnEl = document.getElementById("jsNavBtn");
    this.closeEl = document.getElementById("jsNavClose");
    this.navExpandEls = document.querySelectorAll(".jsNavExpand");
    this.init();
  }

  expand(el) {
    el.addEventListener("click", () => {
      if (el.classList.contains("expand")) {
        el.classList.remove("expand");
        el.parentElement.parentElement.classList.remove("expand");
      } else {
        el.classList.add("expand");
        el.parentElement.parentElement.classList.add("expand");
      }
      e.preventDefault();
    });
  }

  init() {
    if (this.btnEl) {
      this.btnEl.addEventListener("click", () => {
        if (this.el.classList.contains("show")) {
          this.el.classList.remove("show");
        } else {
          this.el.classList.add("show");
        }
      });
    }
    if (this.navExpandEls.length > 0) {
      this.navExpandEls.forEach((navExpandEl) => {
        this.expand(navExpandEl);
      });
    }
    if (this.closeEl) {
      this.closeEl.addEventListener("click", () => {
        this.el.classList.remove("show");
      });
    }
  }
}

window.addEventListener("load", () => {
  new Nav();
});
